import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import Cookies from "js-cookie"
import {
    TERRITORY_HEADER,
    BLOOMREACH_COOKIE_FULL_DOMAIN,
    REALM_HEADER,
    LANGUAGE_HEADER,
    ENTRYPOINT_COOKIE_NAME,
} from "../config/constants"
import {State} from "../ducks"
import {requestCountryChange} from "../ducks/country-selector"
import isSecurePageRequested from "../utils/secureHeader"
import {fromCountrySelectorPage} from "../utils/countryRedirect"

export const mapStateToProps = (state: State) => {
    const {
        countrySelector: {requestedCountryChange, countrySelectorEndpoint},
        data,
        favourites: {enableFavourites},
        request: {
            bloomReachCachingCookieList,
            bloomReachCachingEnabled,
            cookieDomain,
            geolocationBaseUrl,
            geolocationVersion,
            headers,
            showSaleWarningBag,
            cleanSiteUrl,
            tpLitePath,
            url,
        },
        settings: {
            showCheckoutButton,
            showStaticHeaderBanner,
            useBloomreachSegmentCookie,
            developmentToolsEnabled,
            showTestTools,
            enableContentBanner,
            updatedmasid,
            tabbedNavigationEnabled,
            branchIOEnabled,
            seoClientSidePixelEnabled,
            showSignoutButton,
            showMyAccountIcon,
            personalisationDataRetrievalEnabled,
            personalisationDataRetrievalAPIVersion,
            seoClientSidePixelUseEffectEnabled,
            backToSiteBannerEnabled,
            secureHeaderEnabled,
            countrySelectorRedirectEnabled,
            xxlBreakpointEnabled,
            enableMinibagNotification,
            personalisationSessionDataExpirationTime,
            xxlBreakpointMaxWidth,
        },
        shoppingBag: {
            bag: {FirstName},
            itemCount,
        },
        template,
        textAlignment,
    } = state

    if (!Cookies.get(ENTRYPOINT_COOKIE_NAME)) {
        if (backToSiteBannerEnabled) {
            const realm = (headers as IncomingHttpHeaders)[REALM_HEADER] as string
            Cookies.set(ENTRYPOINT_COOKIE_NAME, realm, {expires: 1 / 48}) // 30 minutes = 1/48 of a day
        }
    } else {
        const entrypointCookie = Cookies.getJSON(ENTRYPOINT_COOKIE_NAME)
        Cookies.set(ENTRYPOINT_COOKIE_NAME, entrypointCookie, {expires: 1 / 48}) // 30 minutes = 1/48 of a day
    }
    const queryParams = typeof window !== "undefined" ? window.location.search : ""
    const doCountrySelectorRedirect = !fromCountrySelectorPage(queryParams) && countrySelectorRedirectEnabled
    const isSecure = isSecurePageRequested(url || "") && secureHeaderEnabled
    const displayTestTools = developmentToolsEnabled && showTestTools
    const regions = data?.regions || []
    const hasRegions = regions.length > 0

    if (!data || !regions || !hasRegions) {
        throw new Error("Header: there is no data to render the header")
    }
    return {
        bloomReachCachingCookieList,
        bloomReachCachingEnabled,
        cookieDomain,
        enableCookieConsent: !state.settings["userConsentManagement.enabled"],
        enableFavourites,
        geolocationUrl: geolocationBaseUrl,
        geolocationVersion,
        isBloomreachCookieFullDomain: state.settings[BLOOMREACH_COOKIE_FULL_DOMAIN],
        itemCount,
        requestedCountryChange,
        showCheckoutButton,
        showSaleWarningBag,
        showStaticHeaderBanner,
        displayTestTools,
        templating: template,
        territory: (headers as IncomingHttpHeaders)[TERRITORY_HEADER] as string,
        realm: (headers as IncomingHttpHeaders)[REALM_HEADER] as string,
        language: (headers as IncomingHttpHeaders)[LANGUAGE_HEADER] as string,
        textAlignment,
        useBloomreachSegmentCookie,
        enableContentBanner,
        updatedmasid,
        tabbedNavigationEnabled,
        branchIOEnabled,
        seoClientSidePixelEnabled,
        seoClientSidePixelUseEffectEnabled,
        firstName: FirstName,
        headers: headers as any,
        showSignoutButton,
        showMyAccountIcon,
        cleanSiteUrl,
        tpLitePath,
        personalisationDataRetrievalEnabled,
        personalisationDataRetrievalAPIVersion,
        isSecure,
        doCountrySelectorRedirect,
        countrySelectorEndpoint,
        xxlBreakpointEnabled,
        enableMinibagNotification,
        personalisationSessionDataExpirationTime,
        xxlBreakpointMaxWidth,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    requestCountryChange: () => dispatch(requestCountryChange(false)),
})

export default connect(mapStateToProps, mapDispatchToProps)
